export const isNumber = (str: string): boolean => !Number.isNaN(Number(str));
